'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconUserAlt = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12 8.5A5.506 5.506 0 0 0 6.5 14v3.5a.5.5 0 0 0 .5.5h1.81a.25.25 0 0 1 .249.229l.441 5.313A.5.5 0 0 0 10 24h4a.5.5 0 0 0 .5-.458l.443-5.313A.25.25 0 0 1 15.19 18H17a.5.5 0 0 0 .5-.5V14A5.506 5.506 0 0 0 12 8.5z' }),
    _react2.default.createElement('circle', { cx: '12', cy: '3.5', r: '3.5' }),
    _react2.default.createElement('path', { d: 'M12 8.5A5.506 5.506 0 0 0 6.5 14v3.5a.5.5 0 0 0 .5.5h1.81a.25.25 0 0 1 .249.229l.441 5.313A.5.5 0 0 0 10 24h4a.5.5 0 0 0 .5-.458l.443-5.313A.25.25 0 0 1 15.19 18H17a.5.5 0 0 0 .5-.5V14A5.506 5.506 0 0 0 12 8.5z' }),
    _react2.default.createElement('circle', { cx: '12', cy: '3.5', r: '3.5' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M10 24a.502.502 0 0 1-.498-.458L9.04 18H7a.5.5 0 0 1-.5-.5V14c0-3.033 2.467-5.5 5.5-5.5s5.5 2.467 5.5 5.5v3.5a.5.5 0 0 1-.5.5h-2.04l-.462 5.542A.502.502 0 0 1 14 24h-4zm3.54-1l.462-5.542A.502.502 0 0 1 14.5 17h2v-3c0-2.481-2.019-4.5-4.5-4.5A4.505 4.505 0 0 0 7.5 14v3h2c.258 0 .477.201.498.458L10.46 23h3.08zM12 8C9.794 8 8 6.206 8 4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm0-7c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12 12c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6zm0-10.5C9.519 1.5 7.5 3.519 7.5 6s2.019 4.5 4.5 4.5 4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5zM21.75 24a.75.75 0 0 1-.75-.75c0-4.963-4.037-9-9-9s-9 4.037-9 9a.75.75 0 0 1-1.5 0c0-5.79 4.71-10.5 10.5-10.5s10.5 4.71 10.5 10.5a.75.75 0 0 1-.75.75z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconUserAlt.displayName = 'IconUserAlt';
exports.default = IconUserAlt;